import components from './components'
import styles from './styles'
import config from './config'

export default { components, styles, ...config }
